import React, { useState, useContext, useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { usersRepository } from '../repositories/users_repository'
import { ErrorsContext } from '../contexts/errors_context'
import { AxiosError } from 'axios'
import { Link } from 'react-router-dom'
import { AuthContext } from '../contexts/auth_context'
import { GenericNotFound } from './generic_not_found'

type ForgotPasswordFormData = {
  email: string
}

const ForgotPassword = () => {
  const { t } = useTranslation()
  const { register, handleSubmit } = useForm<ForgotPasswordFormData>()
  const { addError } = useContext(ErrorsContext)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const { isAuthenticated } = useContext(AuthContext)

  const onSubmit = useCallback((data: ForgotPasswordFormData) => {
    if (loading) return

    setLoading(true)

    usersRepository.forgotPassword(data)
      .then(() => {
        setMessage(t('account.forgot_password.success_message'))
      })
      .catch((error: AxiosError) => {
        addError?.(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [loading, addError, t])

  if (isAuthenticated) {
    return <GenericNotFound />
  }

  if (message) {
    return <div className="narrow">
      <h1>{ t('account.forgot_password.title') }</h1>
      <p>{ message }</p>
    </div>
  }

  return (
    <div className="narrow">
      <h1>{ t('account.forgot_password.title') }</h1>
      <p>{ t('account.forgot_password.instructions') }</p>
      <form onSubmit={ handleSubmit(onSubmit) }>
        <p>
          <label>{ t('account.forgot_password.email') }</label>
          <input type="email" className="full" { ...register('email') } autoFocus required />
        </p>
        <p>
          <button className="full" disabled={loading}>
            { t('account.forgot_password.submit') }
          </button>
        </p>
      </form>
      <hr />
      <p>
        <Link to="/login" className='button full white'>
          { t('account.forgot_password.back_to_login') }
        </Link>
      </p>
    </div>
  )
}

export { ForgotPassword }
